/* DubaiCrystal — search by image (dedicated page, on-device).
   Loads TensorFlow.js + MobileNet on first use, embeds the chosen photo in the browser,
   and ranks the store's pre-computed product embeddings by cosine similarity. Nothing is uploaded.
   The "match engine" panel shows the real stages as they happen, paced so each one can be read. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-dc-imgsearch]');
    if (!root || root.hasAttribute('data-dc-imgsearch-ready')) return;
    root.setAttribute('data-dc-imgsearch-ready', '');

    var $ = function (sel) { return root.querySelector(sel); };
    var drop = $('[data-dc-imgsearch-drop]'), file = $('[data-dc-imgsearch-file]'), ops = $('[data-dc-imgsearch-ops]');
    var preview = $('[data-dc-imgsearch-preview]'), status = $('[data-dc-imgsearch-status]'), again = $('[data-dc-imgsearch-again]');
    var results = $('[data-dc-imgsearch-results]'), log = $('[data-dc-imgsearch-log]'), bar = $('[data-dc-imgsearch-bar]');
    var pctEl = $('[data-dc-imgsearch-pct]'), meta = $('[data-dc-imgsearch-meta]');
    var indexUrl = root.getAttribute('data-index');
    var model = null, index = null, loading = null, run = 0;

    var TF = ['https://cdn.jsdelivr.net/npm/@tensorflow/tfjs@4.22.0/dist/tf.min.js', 'https://unpkg.com/@tensorflow/tfjs@4.22.0/dist/tf.min.js'];
    var MN = ['https://cdn.jsdelivr.net/npm/@tensorflow-models/mobilenet@2.1.1/dist/mobilenet.min.js', 'https://unpkg.com/@tensorflow-models/mobilenet@2.1.1/dist/mobilenet.min.js'];

    function loadScript(src) {
      return new Promise(function (res, rej) {
        var s = document.createElement('script'); s.src = src; s.async = true;
        s.onload = function () { res(); };
        s.onerror = function () { s.remove(); rej(new Error('Could not load ' + src)); };
        document.head.appendChild(s);
      });
    }
    function loadAny(list, check) {
      if (check()) return Promise.resolve();
      return list.reduce(function (p, src) { return p.catch(function () { return loadScript(src); }); }, Promise.reject());
    }
    var idxPromise = null;
    function loadIndex() { // { d, products:[{h,t,p,i,n}], owner:[productIndex per vector], vecs: base64 int8 (+128) }
      if (!idxPromise) idxPromise = fetch(indexUrl).then(function (r) { if (!r.ok) throw new Error('index'); return r.json(); }).then(function (idx) {
        var bin = atob(idx.vecs), D = idx.d, M = idx.owner.length;
        var vecs = new Float32Array(M * D), norms = new Float32Array(M);
        for (var k = 0; k < M; k++) { var n = 0; for (var i = 0; i < D; i++) { var v = bin.charCodeAt(k * D + i) - 128; vecs[k * D + i] = v; n += v * v; } norms[k] = Math.sqrt(n) || 1; }
        index = { d: D, products: idx.products, owner: idx.owner, vecs: vecs, norms: norms, m: M };
        return index;
      });
      idxPromise.catch(function () { idxPromise = null; });
      return idxPromise;
    }
    function loadModel(onStep) {
      if (loading) return loading;
      loading = (async function () {
        var idx = loadIndex();
        await loadAny(TF, function () { return !!window.tf; });
        await loadAny(MN, function () { return !!window.mobilenet; });
        if (onStep) onStep('runtime');
        try { await window.tf.setBackend('webgl'); } catch (e) { /* default backend */ }
        await window.tf.ready();
        model = await window.mobilenet.load({ version: 2, alpha: 1.0 });
        await idx;
        if (onStep) onStep('model');
        try { var c = document.createElement('canvas'); c.width = 224; c.height = 224; var w = window.tf.tidy(function () { return model.infer(c, true); }); await w.data(); w.dispose(); } catch (e) { /* ignore */ }
      })();
      loading.catch(function () { loading = null; });
      return loading;
    }
    function show(el, on) { if (!el) return; if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    /* ---- the match-engine theatre: real stages, paced so they can be read ---- */
    var shown = 0, target = 0, raf = 0;
    function paint() {
      shown += (target - shown) * (target >= 100 ? .14 : .06);
      if (target >= 100 && shown > 99.6) shown = 100;
      if (bar) bar.style.width = shown.toFixed(1) + '%';
      if (pctEl) pctEl.innerHTML = Math.round(shown) + '<small>%</small>';
      if (shown < 100) raf = requestAnimationFrame(paint); else raf = 0;
    }
    function setTarget(t) { target = Math.max(target, t); if (!raf) raf = requestAnimationFrame(paint); }
    function Theatre(steps) {
      this.steps = steps; this.i = -1; this.lastAt = 0; this.items = []; this.queue = Promise.resolve(); this.myRun = run;
      log.innerHTML = '';
      var self = this;
      steps.forEach(function (st) {
        var li = document.createElement('li'); li.style.display = 'none';
        li.innerHTML = '<span>' + esc(st.label) + '</span>' + (st.meta ? '<small>' + esc(st.meta) + '</small>' : '');
        log.appendChild(li); self.items.push(li);
      });
    }
    Theatre.prototype.advance = function () { // mark the current step done and start the next; never faster than each step's minimum time
      var self = this;
      this.queue = this.queue.then(async function () {
        if (self.myRun !== run) return;
        var now = Date.now();
        if (self.i >= 0) { var min = self.steps[self.i].min || 0, wait = self.lastAt + min - now; if (wait > 0) await sleep(wait); }
        if (self.myRun !== run) return;
        if (self.i >= 0) { self.items[self.i].classList.remove('is-active'); self.items[self.i].classList.add('is-done'); }
        self.i++; self.lastAt = Date.now();
        if (self.i < self.steps.length) {
          var li = self.items[self.i]; li.style.display = ''; li.classList.add('is-active');
          setTarget(self.steps[self.i].pct);
        }
      });
      return this.queue;
    };

    /* ---- events ---- */
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      drop.addEventListener(ev, function () { loadModel().catch(function () {}); }, { once: true, passive: true });
    });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files && e.dataTransfer.files[0]; if (f) handle(f); });
    file.addEventListener('change', function () { if (file.files && file.files[0]) handle(file.files[0]); file.value = ''; });
    document.addEventListener('paste', function (e) {
      var items = e.clipboardData && e.clipboardData.items; if (!items) return;
      for (var i = 0; i < items.length; i++) if (items[i].type.indexOf('image') === 0) { handle(items[i].getAsFile()); break; }
    });
    again.addEventListener('click', function () {
      run++; if (raf) cancelAnimationFrame(raf); raf = 0;
      ops.classList.remove('is-done'); show(ops, false); show(drop, true); results.innerHTML = ''; status.textContent = ''; if (meta) meta.textContent = '';
    });

    async function handle(f) {
      if (!f || (f.type && f.type.indexOf('image') !== 0)) return;
      var myRun = ++run;
      var url = URL.createObjectURL(f);
      preview.src = url; show(drop, false); show(ops, true); ops.classList.remove('is-done'); results.innerHTML = ''; status.textContent = '';
      shown = 0; target = 0; if (bar) bar.style.width = '0%'; if (pctEl) pctEl.innerHTML = '0<small>%</small>';
      if (meta) meta.textContent = 'Runs on your device · nothing is uploaded';
      var total = index ? index.products.length : 610;
      var th = new Theatre([
        { label: 'Preparing the visual matcher', meta: 'AI model', pct: 14, min: 650 },
        { label: 'Loading the vision model', meta: 'On your device', pct: 34, min: 800 },
        { label: 'Reading your photo', meta: 'Shape & cut', pct: 50, min: 650 },
        { label: 'Understanding the piece', meta: '1,280 visual features', pct: 68, min: 800 },
        { label: 'Comparing with our range', meta: fmt(total) + ' pieces · every photo', pct: 88, min: 900 },
        { label: 'Ranking the closest pieces', meta: 'Top 8', pct: 97, min: 600 }
      ]);
      try {
        th.advance(); // step 0 running
        var reached = { runtime: false, model: false };
        var modelP = loadModel(function (s) { reached[s] = true; });
        var imgP = new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = url; });
        // runtime scripts → step 1
        await Promise.race([modelP, (async function () { while (!reached.runtime) await sleep(60); })()]);
        if (myRun !== run) return;
        await th.advance();
        await modelP; // model + index ready → step 2
        if (myRun !== run) return;
        await th.advance();
        var img = await imgP;
        var iw = img.naturalWidth, ih = img.naturalHeight;
        function crop(fx, fy, fw, fh) { // fraction box of the source → 224 canvas, letterboxed on white
          var c = document.createElement('canvas'); c.width = 224; c.height = 224;
          var cx = c.getContext('2d'); cx.fillStyle = '#fff'; cx.fillRect(0, 0, 224, 224);
          var sw = iw * fw, sh = ih * fh, sc = Math.min(224 / sw, 224 / sh), w = sw * sc, h = sh * sc;
          cx.drawImage(img, iw * fx, ih * fy, sw, sh, (224 - w) / 2, (224 - h) / 2, w, h);
          return c;
        }
        function objectBox() { // bounding box of the largest mid-tone blob (ignores white page background and dark UI bars) — finds the piece in a screenshot
          var G = 96, c = document.createElement('canvas'); c.width = G; c.height = G; var cx = c.getContext('2d');
          cx.drawImage(img, 0, 0, G, G); var d = cx.getImageData(0, 0, G, G).data, m = new Uint8Array(G * G);
          for (var i = 0; i < G * G; i++) { var r = d[i*4], g = d[i*4+1], b = d[i*4+2], l = (r*299 + g*587 + b*114) / 1000, sat = Math.max(r,g,b) - Math.min(r,g,b); m[i] = (l > 28 && l < 232) || sat > 40 ? 1 : 0; }
          var seen = new Uint8Array(G * G), best = null, stack = [];
          for (var st = 0; st < G * G; st++) {
            if (!m[st] || seen[st]) continue;
            var x0 = G, x1 = 0, y0 = G, y1 = 0, cnt = 0; stack.push(st); seen[st] = 1;
            while (stack.length) { var k = stack.pop(), x = k % G, y = (k - x) / G; cnt++; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
              var nb = [k - 1, k + 1, k - G, k + G, k - G - 1, k - G + 1, k + G - 1, k + G + 1];
              for (var q = 0; q < 8; q++) { var n = nb[q]; if (n < 0 || n >= G * G || seen[n] || !m[n]) continue; if (Math.abs((n % G) - x) > 1) continue; seen[n] = 1; stack.push(n); } }
            var cw = (x1 - x0 + 1) / G, ch = (y1 - y0 + 1) / G, bar = (ch < .14 && cw > .7) || (cw < .14 && ch > .7); // skip UI bars / rules
            if (!bar && (!best || cnt > best.cnt)) best = { cnt: cnt, x0: x0, x1: x1, y0: y0, y1: y1 };
          }
          if (!best) return null;
          var bw = (best.x1 - best.x0 + 1) / G, bh = (best.y1 - best.y0 + 1) / G;
          if (bw * bh < 0.03 || bw * bh > 0.85) return null;
          var pad = 0.08, fx = Math.max(0, best.x0 / G - pad * bw), fy = Math.max(0, best.y0 / G - pad * bh);
          return [fx, fy, Math.min(1 - fx, bw * (1 + 2 * pad)), Math.min(1 - fy, bh * (1 + 2 * pad))];
        }
        var crops = [crop(0, 0, 1, 1), crop(.125, .125, .75, .75), crop(.225, .225, .55, .55)];
        var ob = null; try { ob = objectBox(); } catch (e) { ob = null; }
        if (ob) crops.push(crop(ob[0], ob[1], ob[2], ob[3]));
        await th.advance(); // → step 3: features
        var qs = [];
        for (var ci = 0; ci < crops.length; ci++) {
          var emb = window.tf.tidy(function () { return model.infer(crops[ci], true); });
          var q = Array.from(await emb.data()); emb.dispose();
          var qn = 0; for (var i = 0; i < q.length; i++) qn += q[i] * q[i]; qn = Math.sqrt(qn) || 1;
          qs.push({ q: q, n: qn });
          await sleep(0);
        }
        if (myRun !== run) return;
        await th.advance(); // → step 4: compare
        var D = index.d, best = new Float32Array(index.products.length).fill(-1);
        for (var k = 0; k < index.m; k++) {
          var off = k * D, sBest = -1;
          for (var ci = 0; ci < qs.length; ci++) {
            var q = qs[ci].q, d = 0;
            for (var i = 0; i < D; i++) d += q[i] * index.vecs[off + i];
            var sc = d / (qs[ci].n * index.norms[k]);
            // the full photo counts a little more than the tighter crops
            sc = (ci === 0 || (ob && ci === qs.length - 1)) ? sc : sc - 0.015;
            if (sc > sBest) sBest = sc;
          }
          var pi = index.owner[k]; if (sBest > best[pi]) best[pi] = sBest;
        }
        var scored = index.products.map(function (p, i) { return { p: p, s: best[i] }; });
        if (window.__dcDebug) window.__dcLast = { scored: scored, qs: qs };
        await th.advance(); // → step 5: rank
        scored.sort(function (a, b) { return b.s - a.s; });
        var top = scored.slice(0, 8);
        await th.advance(); // all done
        if (myRun !== run) return;
        setTarget(100);
        ops.classList.add('is-done');
        status.textContent = 'These are the most similar pieces in our range — closest match first.';
        if (meta) meta.textContent = 'Compared with ' + fmt(index.products.length) + ' pieces · nothing was uploaded';
        results.innerHTML = top.map(function (r, i) {
          return '<li class="dc-isp__item" style="--i:' + i + '"><a href="/products/' + esc(r.p.h) + '">' +
            '<span class="dc-isp__thumb"><img src="' + esc(r.p.i) + '?width=500" alt="" loading="' + (i < 4 ? 'eager' : 'lazy') + '"></span>' +
            '<span class="dc-isp__rank">' + (i === 0 ? 'Closest match' : 'Match ' + (i + 1)) + '</span>' +
            '<span class="dc-isp__ptitle">' + esc(r.p.t) + '</span>' +
            '<span class="dc-isp__price">Dhs. ' + esc(r.p.p) + '</span></a></li>';
        }).join('');
      } catch (e) {
        if (myRun !== run) return;
        ops.classList.add('is-done');
        status.textContent = 'We could not run the visual matcher right now. Please try again, or send us the photo on WhatsApp and we will find the piece for you.';
        if (window.console) console.warn('[DubaiCrystal] image search:', e);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
